import { useRef, useState } from "react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const SEARCH_DEBOUNCE_MS = 400;
const MIN_QUERY_LENGTH = 2;

export const useCompanySearch = () => {
  const [companyResults, setCompanyResults] = useState([]);
  const [searchingCo, setSearchingCo] = useState(false);
  const [showCoDropdown, setShowCoDropdown] = useState(false);
  const coTimer = useRef(null);

  const search = (q) => {
    clearTimeout(coTimer.current);
    if (q.trim().length < MIN_QUERY_LENGTH) {
      setCompanyResults([]);
      setShowCoDropdown(false);
      return;
    }
    coTimer.current = setTimeout(async () => {
      setSearchingCo(true);
      try {
        const res = await axios.get(`${API}/companies/search`, { params: { q } });
        setCompanyResults(res.data);
        setShowCoDropdown(true);
      } catch {
        setCompanyResults([]);
      } finally {
        setSearchingCo(false);
      }
    }, SEARCH_DEBOUNCE_MS);
  };

  return { companyResults, searchingCo, showCoDropdown, setShowCoDropdown, search };
};
